import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { configSelectors } from '@/store/configs'
import Content from './content'
import { searchActions } from '@/store/search'
import { customerHelper } from '@tweddle-se-team/common/constants'
import SubaruContent from '@/components/themes/subaru/landing/content'
import CustomerNotFound from '@/components/shared/customerNotFound'

const { CUSTOMER_IDS } = customerHelper

const chooseVehicleMapper = {
  [CUSTOMER_IDS.SUBARU]: SubaruContent,
  [CUSTOMER_IDS.TME]: Content,
  [CUSTOMER_IDS.NORDICS]: SubaruContent
}

const Landing = () => {
  const dispatch = useDispatch()
  const { customerId } = useSelector(configSelectors.selectConfigs)

  useEffect(() => {
    // Reset search status when going back to landing page
    dispatch(searchActions.SET_PANE({}))
    dispatch(searchActions.RESET_FILTERS())
  }, [dispatch])

  const BrandedContent = chooseVehicleMapper[customerId] || CustomerNotFound

  return <BrandedContent />
}

export default Landing
